module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Z76rXk/tc-custom/9781459293205.jpg?1721429419399",
      "alt": "This image is the cover for the book Cipriani's Innocent Captive"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cipriani's Innocent Captive\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In paradise—as his prisoner!")]), _c('br'), _c('br'), _vm._v("One of Lucas Cipriani’s employees has information which could ruin a vital takeover—and he’s furious! The only way to handle temptress Katy Brennan is to hold her captive on his yacht for a fortnight, cut off from the world until the deal is complete…"), _c('br'), _c('br'), _vm._v("Katy is infuriated by her billionaire boss’s high-handed behavior—but also unwillingly intrigued by the gorgeous CEO. Once she’s alone and at his mercy, Lucas begins to let Katy see past his steely exterior. Soon she’s shockingly tempted to indulge in a forbidden fling…and relinquish her innocence!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cathy Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cathy Williams is a great believer in the power of perseverance as she had never written anything before her writing career, and from the starting point of zero has now fulfilled her ambition to pursue this most enjoyable of careers. She would encourage any would-be writer to have faith and go for it! She derives inspiration from the tropical island of Trinidad and from the peaceful countryside of middle England. Cathy lives in Warwickshire her family.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0